import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const Card = ({ 
  children, 
  title, 
  subtitle,
  headerAction,
  padding = true,
  compact = false,
  hoverable = false,
  className = '',
  cardStyle,
  bodyStyle,
  headerStyle,
}) => {
  const { theme } = useTheme();
  const [isHovered, setIsHovered] = React.useState(false);

  const cardBase = {
    backgroundColor: theme.colors.cardBg,
    borderRadius: '12px',
    border: `1px solid ${theme.colors.border}`,
    boxShadow: isHovered && hoverable ? theme.shadows.md : theme.shadows.sm,
    overflow: 'hidden',
    transition: 'transform 0.2s, box-shadow 0.2s',
    ...(hoverable && isHovered && {
      transform: 'translateY(-2px)',
    }),
  };

  return (
    <div 
      style={{ ...cardBase, ...cardStyle }} 
      className={className}
      onMouseEnter={() => hoverable && setIsHovered(true)}
      onMouseLeave={() => hoverable && setIsHovered(false)}
    >
      {(title || headerAction) && (
        <div style={{
          padding: compact ? '14px 18px' : '18px 22px',
          borderBottom: `1px solid ${theme.colors.border}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          ...headerStyle,
        }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            {title && (
              <h3 style={{
                fontSize: '16px', fontWeight: '600', color: theme.colors.text,
                marginBottom: subtitle ? '3px' : 0,
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              }}>
                {title}
              </h3>
            )}
            {subtitle && (
              <p style={{ fontSize: '13px', color: theme.colors.textSecondary }}>{subtitle}</p>
            )}
          </div>
          {headerAction}
        </div>
      )}
      <div style={{ padding: !padding ? 0 : compact ? '14px 18px' : '22px', ...bodyStyle }}>
        {children}
      </div>
    </div>
  );
};

export default Card;

